import { useEffect, useState } from "react";
import { getArticlesByArticleType } from "../api/widgets/articlesByArticleType/requests";

export const useStoryblokArticlesByArticleTypeWidget = (articleType) => {
  const [isLoading, setIsLoading] = useState(true);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    getArticlesByArticleType(articleType)
      .then(data => {
        if (data) {
          setArticles(data.articles);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false));
  }, [articleType]);

  return [articles, isLoading];
}